import { HttpErrorResponse } from "@angular/common/http";
import { DettaglioErroreVO } from "./dettaglio-erroreVO";

export class ErrorVO {
  error: string;
  exception: string;
  path: string;
  status: number;
  timestamp: number;
  message: string;
  listaErrori: DettaglioErroreVO[];

  public setErrorDetails(err: any) {
    try {
      console.log("setErrorDetails: ", err);
      if (err instanceof HttpErrorResponse) {
        if (err.error instanceof ErrorEvent) {
          this.message = err.error.message;
        } else {
          if (err.error && (err as HttpErrorResponse).error.descrizione) {
            this.message = err.error.descrizione;
          } else if (err.error && err.error.message) {
            this.message = err.error.message;
          } else if (
            err.error &&
            err.error.errori &&
            err.error.errori.length > 0
          ) {
            this.listaErrori = err.error.errori;
            this.message = err.message;
            this.status = err.status;
          } else {
            this.message = err.message;
          }
        }
      } else {
        const jsonErr = err.json();
        console.log("setErrorDetails: ", jsonErr);
        this.error = jsonErr.error;
        this.exception = jsonErr.exception;
        this.path = jsonErr.path;
        this.status = jsonErr.status;
        this.timestamp = jsonErr.timestamp;
        if (jsonErr.message !== undefined) {
          this.message = jsonErr.message;
        } else {
          this.message = jsonErr.descrizione;
        }
      }
    } catch (e) {
      console.log("Errore decodifica errore:", e);
      this.message = err;
    }
    // console.log("setErrorDetails this: ", this);
  }

  public setErrorMsg(message: string) {
    this.message = message;
  }
}
